import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './ProfileSidebar.css';

// Иконка цветовой палитры
const PaletteIcon = () => (
  <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C12.39 22 12.78 21.97 13.16 21.94C13.68 21.89 14 21.41 14 20.88V20.5C14 19.67 14.67 19 15.5 19H16C18.21 19 20 17.21 20 15V14.5C20 13.67 20.67 13 21.5 13C21.78 13 22 12.78 22 12.5C22 6.72 17.51 2 12 2ZM6.5 13C5.67 13 5 12.33 5 11.5C5 10.67 5.67 10 6.5 10C7.33 10 8 10.67 8 11.5C8 12.33 7.33 13 6.5 13ZM8.5 8C7.67 8 7 7.33 7 6.5C7 5.67 7.67 5 8.5 5C9.33 5 10 5.67 10 6.5C10 7.33 9.33 8 8.5 8ZM12 6C11.17 6 10.5 5.33 10.5 4.5C10.5 3.67 11.17 3 12 3C12.83 3 13.5 3.67 13.5 4.5C13.5 5.33 12.83 6 12 6ZM15.5 8C14.67 8 14 7.33 14 6.5C14 5.67 14.67 5 15.5 5C16.33 5 17 5.67 17 6.5C17 7.33 16.33 8 15.5 8Z" fill="#838383"/>
  </svg>
);

const PaletteIconActive = () => (
  <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="paletteGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffe866"/>
        <stop offset="100%" stopColor="#ffc814"/>
      </linearGradient>
    </defs>
    <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C12.39 22 12.78 21.97 13.16 21.94C13.68 21.89 14 21.41 14 20.88V20.5C14 19.67 14.67 19 15.5 19H16C18.21 19 20 17.21 20 15V14.5C20 13.67 20.67 13 21.5 13C21.78 13 22 12.78 22 12.5C22 6.72 17.51 2 12 2ZM6.5 13C5.67 13 5 12.33 5 11.5C5 10.67 5.67 10 6.5 10C7.33 10 8 10.67 8 11.5C8 12.33 7.33 13 6.5 13ZM8.5 8C7.67 8 7 7.33 7 6.5C7 5.67 7.67 5 8.5 5C9.33 5 10 5.67 10 6.5C10 7.33 9.33 8 8.5 8ZM12 6C11.17 6 10.5 5.33 10.5 4.5C10.5 3.67 11.17 3 12 3C12.83 3 13.5 3.67 13.5 4.5C13.5 5.33 12.83 6 12 6ZM15.5 8C14.67 8 14 7.33 14 6.5C14 5.67 14.67 5 15.5 5C16.33 5 17 5.67 17 6.5C17 7.33 16.33 8 15.5 8Z" fill="url(#paletteGradient)"/>
  </svg>
);

// Иконки
const GearIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <g clipPath="url(#clip0_10_4)">
      <path d="M12.3441 1.37812C11.802 -0.459375 9.198 -0.459375 8.65594 1.37812L8.52469 1.82438C8.4437 2.09947 8.30216 2.35294 8.11045 2.56622C7.91875 2.77949 7.68174 2.94715 7.4168 3.0569C7.15186 3.16665 6.86572 3.2157 6.57936 3.20047C6.293 3.18524 6.01367 3.10611 5.76187 2.96888L5.355 2.74575C3.67106 1.82963 1.82962 3.67106 2.74706 5.35369L2.96888 5.76187C3.55425 6.83812 2.99906 8.17819 1.82438 8.52469L1.37812 8.65594C-0.459375 9.198 -0.459375 11.802 1.37812 12.3441L1.82438 12.4753C2.09947 12.5563 2.35294 12.6978 2.56622 12.8895C2.77949 13.0813 2.94715 13.3183 3.0569 13.5832C3.16665 13.8481 3.2157 14.1343 3.20047 14.4206C3.18524 14.707 3.10611 14.9863 2.96888 15.2381L2.74575 15.645C1.82963 17.3289 3.67106 19.1704 5.35369 18.2529L5.76187 18.0311C6.01367 17.8939 6.293 17.8148 6.57936 17.7995C6.86572 17.7843 7.15186 17.8334 7.4168 17.9431C7.68174 18.0529 7.91875 18.2205 8.11045 18.4338C8.30216 18.6471 8.4437 18.9005 8.52469 19.1756L8.65594 19.6219C9.198 21.4594 11.802 21.4594 12.3441 19.6219L12.4753 19.1756C12.5563 18.9005 12.6978 18.6471 12.8895 18.4338C13.0813 18.2205 13.3183 18.0529 13.5832 17.9431C13.8481 17.8334 14.1343 17.7843 14.4206 17.7995C14.707 17.8148 14.9863 17.8939 15.2381 18.0311L15.645 18.2542C17.3289 19.1704 19.1704 17.3289 18.2529 15.6463L18.0311 15.2381C17.8939 14.9863 17.8148 14.707 17.7995 14.4206C17.7843 14.1343 17.8334 13.8481 17.9431 13.5832C18.0529 13.3183 18.2205 13.0813 18.4338 12.8895C18.6471 12.6978 18.9005 12.5563 19.1756 12.4753L19.6219 12.3441C21.4594 11.802 21.4594 9.198 19.6219 8.65594L19.1756 8.52469C18.9005 8.4437 18.6471 8.30216 18.4338 8.11045C18.2205 7.91875 18.0529 7.68174 17.9431 7.4168C17.8334 7.15186 17.7843 6.86572 17.7995 6.57936C17.8148 6.293 17.8939 6.01367 18.0311 5.76187L18.2542 5.355C19.1704 3.67106 17.3289 1.82962 15.6463 2.74706L15.2381 2.96888C14.9863 3.10611 14.707 3.18524 14.4206 3.20047C14.1343 3.2157 13.8481 3.16665 13.5832 3.0569C13.3183 2.94715 13.0813 2.77949 12.8895 2.56622C12.6978 2.35294 12.5563 2.09947 12.4753 1.82438L12.3441 1.37812ZM10.5 14.3456C9.48008 14.3456 8.50193 13.9405 7.78073 13.2193C7.05954 12.4981 6.65438 11.5199 6.65438 10.5C6.65438 9.48008 7.05954 8.50193 7.78073 7.78073C8.50193 7.05954 9.48008 6.65438 10.5 6.65438C11.5196 6.65438 12.4974 7.0594 13.2183 7.78035C13.9393 8.5013 14.3443 9.47911 14.3443 10.4987C14.3443 11.5183 13.9393 12.4961 13.2183 13.217C12.4974 13.938 11.5196 14.343 10.5 14.343V14.3456Z" fill="#838383"/>
    </g>
    <defs>
      <clipPath id="clip0_10_4">
        <rect width="21" height="21" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const GameIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM11 13H9V15H7V13H5V11H7V9H9V11H11V13ZM15.5 14C14.67 14 14 13.33 14 12.5C14 11.67 14.67 11 15.5 11C16.33 11 17 11.67 17 12.5C17 13.33 16.33 14 15.5 14ZM18.5 11C17.67 11 17 10.33 17 9.5C17 8.67 17.67 8 18.5 8C19.33 8 20 8.67 20 9.5C20 10.33 19.33 11 18.5 11Z" fill="#676767"/>
  </svg>
);

// Аватар пользователя загружается из public
const avatarUrl = '/images/avatar.png';

// Активная иконка (желтый градиент)
const GearIconActive = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <defs>
      <linearGradient id="gearGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffe866"/>
        <stop offset="100%" stopColor="#ffc814"/>
      </linearGradient>
    </defs>
    <g clipPath="url(#clip0_10_4_active)">
      <path d="M12.3441 1.37812C11.802 -0.459375 9.198 -0.459375 8.65594 1.37812L8.52469 1.82438C8.4437 2.09947 8.30216 2.35294 8.11045 2.56622C7.91875 2.77949 7.68174 2.94715 7.4168 3.0569C7.15186 3.16665 6.86572 3.2157 6.57936 3.20047C6.293 3.18524 6.01367 3.10611 5.76187 2.96888L5.355 2.74575C3.67106 1.82963 1.82962 3.67106 2.74706 5.35369L2.96888 5.76187C3.55425 6.83812 2.99906 8.17819 1.82438 8.52469L1.37812 8.65594C-0.459375 9.198 -0.459375 11.802 1.37812 12.3441L1.82438 12.4753C2.09947 12.5563 2.35294 12.6978 2.56622 12.8895C2.77949 13.0813 2.94715 13.3183 3.0569 13.5832C3.16665 13.8481 3.2157 14.1343 3.20047 14.4206C3.18524 14.707 3.10611 14.9863 2.96888 15.2381L2.74575 15.645C1.82963 17.3289 3.67106 19.1704 5.35369 18.2529L5.76187 18.0311C6.01367 17.8939 6.293 17.8148 6.57936 17.7995C6.86572 17.7843 7.15186 17.8334 7.4168 17.9431C7.68174 18.0529 7.91875 18.2205 8.11045 18.4338C8.30216 18.6471 8.4437 18.9005 8.52469 19.1756L8.65594 19.6219C9.198 21.4594 11.802 21.4594 12.3441 19.6219L12.4753 19.1756C12.5563 18.9005 12.6978 18.6471 12.8895 18.4338C13.0813 18.2205 13.3183 18.0529 13.5832 17.9431C13.8481 17.8334 14.1343 17.7843 14.4206 17.7995C14.707 17.8148 14.9863 17.8939 15.2381 18.0311L15.645 18.2542C17.3289 19.1704 19.1704 17.3289 18.2529 15.6463L18.0311 15.2381C17.8939 14.9863 17.8148 14.707 17.7995 14.4206C17.7843 14.1343 17.8334 13.8481 17.9431 13.5832C18.0529 13.3183 18.2205 13.0813 18.4338 12.8895C18.6471 12.6978 18.9005 12.5563 19.1756 12.4753L19.6219 12.3441C21.4594 11.802 21.4594 9.198 19.6219 8.65594L19.1756 8.52469C18.9005 8.4437 18.6471 8.30216 18.4338 8.11045C18.2205 7.91875 18.0529 7.68174 17.9431 7.4168C17.8334 7.15186 17.7843 6.86572 17.7995 6.57936C17.8148 6.293 17.8939 6.01367 18.0311 5.76187L18.2542 5.355C19.1704 3.67106 17.3289 1.82962 15.6463 2.74706L15.2381 2.96888C14.9863 3.10611 14.707 3.18524 14.4206 3.20047C14.1343 3.2157 13.8481 3.16665 13.5832 3.0569C13.3183 2.94715 13.0813 2.77949 12.8895 2.56622C12.6978 2.35294 12.5563 2.09947 12.4753 1.82438L12.3441 1.37812ZM10.5 14.3456C9.48008 14.3456 8.50193 13.9405 7.78073 13.2193C7.05954 12.4981 6.65438 11.5199 6.65438 10.5C6.65438 9.48008 7.05954 8.50193 7.78073 7.78073C8.50193 7.05954 9.48008 6.65438 10.5 6.65438C11.5196 6.65438 12.4974 7.0594 13.2183 7.78035C13.9393 8.5013 14.3443 9.47911 14.3443 10.4987C14.3443 11.5183 13.9393 12.4961 13.2183 13.217C12.4974 13.938 11.5196 14.343 10.5 14.343V14.3456Z" fill="url(#gearGradient)"/>
    </g>
    <defs>
      <clipPath id="clip0_10_4_active">
        <rect width="21" height="21" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

// Color picker items configuration
const colorPickerItems = [
  { id: 'bg-primary', label: 'Фон страницы', cssVar: '--color-bg-primary', defaultValue: '#161616' },
  { id: 'bg-block', label: 'Фон блока', cssVar: '--color-block-bg', defaultValue: '#0d0d0d' },
  { id: 'bg-inner', label: 'Фон внутреннего блока', cssVar: '--color-inner-block-bg', defaultValue: '#0d0d0d' },
  { id: 'border', label: 'Цвет обводки', cssVar: '--color-border', defaultValue: '#838383' },
  { id: 'accent', label: 'Акцент-цвет', cssVar: '--color-accent-start', defaultValue: '#ffe866' },
];

const ProfileSidebar = ({ activeItem = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [showColorPickers, setShowColorPickers] = useState(false);
  const [colors, setColors] = useState(() => {
    const initial = {};
    colorPickerItems.forEach(item => {
      initial[item.id] = item.defaultValue;
    });
    return initial;
  });
  const colorInputRefs = useRef({});
  
  const userName = user?.first_name || 'Пользователь';
  const userEmail = user?.email || '';

  // Convert hex to rgba
  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  // Handle color change
  const handleColorChange = (itemId, cssVar, value) => {
    setColors(prev => ({ ...prev, [itemId]: value }));
    
    // Update CSS variable
    if (cssVar === '--color-accent-start') {
      // For accent color, update both start and end
      document.documentElement.style.setProperty('--color-accent-start', value);
      document.documentElement.style.setProperty('--color-accent-end', value);
      document.documentElement.style.setProperty('--color-accent-start-opacity', value);
      document.documentElement.style.setProperty('--color-accent-end-opacity', value);
    } else if (cssVar === '--color-border') {
      // For border, we need to update with transparency
      document.documentElement.style.setProperty('--color-border', hexToRgba(value, 0.1));
      document.documentElement.style.setProperty('--color-divider', hexToRgba(value, 0.1));
    } else if (cssVar === '--color-block-bg' || cssVar === '--color-inner-block-bg') {
      // For block backgrounds, add transparency
      document.documentElement.style.setProperty(cssVar, hexToRgba(value, 0.5));
    } else {
      document.documentElement.style.setProperty(cssVar, value);
    }
  };

  const openColorPicker = (itemId) => {
    colorInputRefs.current[itemId]?.click();
  };

  const menuItems = [
    { id: 'purchase', label: 'Как происходит процесс покупки', path: '/how-to-buy' },
    { id: 'faq', label: 'FAQ', path: '/faq' },
    { id: 'orders', label: 'История заказов', path: '/orders' },
    { id: 'social', label: 'Наши социальные сети', path: '/social' },
  ];

  // Determine active item from current path
  const currentActiveItem = activeItem || menuItems.find(item => item.path === location.pathname)?.id;

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  return (
    <aside className="profile-sidebar">
      {/* Профиль пользователя */}
      <button className="profile-sidebar__user" onClick={handleProfileClick}>
        <div className="profile-sidebar__avatar">
          <img src={user?.photo || avatarUrl} alt="Avatar" />
        </div>
        <div className="profile-sidebar__info">
          <h2 className="profile-sidebar__name">{userName}</h2>
          <p className="profile-sidebar__email">{userEmail.toLowerCase()}</p>
        </div>
      </button>

      {/* Меню */}
      <nav className="profile-sidebar__menu">
        {menuItems.map((item, index) => (
          <React.Fragment key={item.id}>
            <button 
              className={`profile-sidebar__menu-item ${currentActiveItem === item.id ? 'profile-sidebar__menu-item--active' : ''}`}
              onClick={() => handleNavigate(item.path)}
            >
              {/* Индикатор активного пункта */}
              {currentActiveItem === item.id && (
                <div className="profile-sidebar__active-indicator" />
              )}
              {currentActiveItem === item.id ? <GearIconActive /> : <GearIcon />}
              <span>{item.label}</span>
            </button>
            {index < menuItems.length - 1 && <div className="profile-sidebar__divider" />}
          </React.Fragment>
        ))}
      </nav>

      <div className="profile-sidebar__divider" />

      {/* Color Picker Section */}
      {/* <button 
        className={`profile-sidebar__menu-item ${showColorPickers ? 'profile-sidebar__menu-item--active' : ''}`}
        onClick={() => setShowColorPickers(!showColorPickers)}
      >
        {showColorPickers && <div className="profile-sidebar__active-indicator" />}
        {showColorPickers ? <PaletteIconActive /> : <PaletteIcon />}
        <span>Настройка цветов (демо)</span>
      </button> */}

      {showColorPickers && (
        <div className="profile-sidebar__color-pickers">
          {colorPickerItems.map((item) => (
            <div key={item.id} className="profile-sidebar__color-item">
              <span className="profile-sidebar__color-label">{item.label}</span>
              <div 
                className="profile-sidebar__color-preview"
                style={{ backgroundColor: colors[item.id] }}
                onClick={() => openColorPicker(item.id)}
              />
              <input
                ref={el => colorInputRefs.current[item.id] = el}
                type="color"
                value={colors[item.id]}
                onChange={(e) => handleColorChange(item.id, item.cssVar, e.target.value)}
                className="profile-sidebar__color-input"
              />
            </div>
          ))}
        </div>
      )}

      <div className="profile-sidebar__divider" />

      {/* Действия */}
      <div className="profile-sidebar__actions">
        <button 
          className="profile-sidebar__btn profile-sidebar__btn--outline"
          onClick={() => navigate('/all-games')}
        >
          <GameIcon />
          <span>Все игры и приложения</span>
        </button>
        <button 
          className="profile-sidebar__btn profile-sidebar__btn--primary"
          onClick={() => navigate('/chat')}
        >
          Перейти к диалогу с администратором для покупки доната
        </button>
      </div>
    </aside>
  );
};

export default ProfileSidebar;
